/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

/**
 * This model
 * @type {[type]}
 */
module.exports = Model({
	name: "autoreply",
	init: init,
	listeners: listeners,
	triggers: triggers,
	refresh: refresh,
	clear_autoreply: clear_autoreply,
	_loaded: false,
});

function init() {
	this._localization = {};

	this.push({
		autoreply: false,
	});
	this.refresh();
}

function listeners() {
	return {
		"mqtt:$/message/autoreply/update": handle_autoreply_update,
		"connectivity:online": refresh,
		"localization:updated": handle_localization_updated,
	};
}

function triggers() {
	return {
		"view": view,
		"update": update_autoreply,
		"clear": clear_autoreply,
	};
}

function handle_localization_updated(localization) {
	this._localization = localization;
}

function view() {
	this._loaded = true;
	this.refresh();
}

/**
 * Refreshses the value of autoreply and pushes it
 */
function refresh() {
	if(!this._loaded) return;
	this.api.messages
		.autoreply
		.status()
		.then(handle_autoreply_update.bind(this))
		.catch(console.error.bind(console));
}

// update the local state
function handle_autoreply_update(data) {
	var autoreply = data.autoreply;
	this.push(autoreply);
}

function update_autoreply(data) {
	var autoreply = data.autoreply;
	if (!autoreply) {
		this.clear_autoreply();
	}
	else {
		this.emit("save:trigger:start");
		this.api.messages
			.autoreply
			.update(autoreply)
			.catch(console.error.bind(console))
			.then(doneSaving.bind(this));
		this.emit("usermetrics:trigger:track", "update autoreply");
	}
}

function doneSaving() {
	this.emit("save:trigger:finish");
	var message = "autoreply.saved";
	this.emit("toast:trigger:show", {
		content: message
	});
}

function clear_autoreply() {
	this.emit("save:trigger:start");
	this.api.messages
		.autoreply
		.clear()
		.catch(console.error.bind(console))
		.then(doneSaving.bind(this));
	this.emit("usermetrics:trigger:track", "clear autoreply");
}
